module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-MedItalic.2f20edb.woff";